import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirection2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDirection2"><Path d="M10.9994 3V8H4.51875L1.71875 11.5L4.51875 15H10.9994V19H6.99937V21H16.9994V19H12.9994V10H19.48L22.28 6.5L19.48 3H10.9994Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDirection2;
